import styled from 'styled-components';
import { InputText } from 'ui/inputs';
import { body2, colors, spacing, fontWeights } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Details = styled.div`
  background: ${colors.grey5};
  border-radius: ${spacing.half};
  margin-top: ${spacing.plusHalf};
  &:not(:empty) {
    padding: ${spacing.plusHalf};
  }
`;

export const StyledInput = styled(InputText)`
  margin-bottom: ${spacing.half};
`;

export const Detail = styled.div`
  ${body2};
  display: flex;
  margin-bottom: ${spacing.plusHalf};
  color: ${colors.textSecondary};
  > div:nth-child(odd) {
    color: ${colors.textPrimary};
    font-weight: ${fontWeights.medium};
    width: ${pxToRem(140)};
    flex-shrink: 0;
  }
  :last-child {
    margin-bottom: 0;
  }
`;

export const DetailText = styled.div`
  margin-bottom: ${spacing.base};
  line-height: ${spacing.plusQuarter};
  :last-child {
    margin-bottom: 0;
  }
`;

export const SwitchProjectLink = styled.p`
  margin-bottom: ${spacing.quarter};
  color: ${colors.textLink};
  text-decoration: underline;
  cursor: pointer;
  :hover {
    color: ${colors.textLink};
  }
`;

export const DateText = styled.p`
  color: ${colors.textPrimary};
  margin-bottom: ${spacing.half};
`;

export const UserText = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
